import { SxProps } from "@mui/material";
import theme, { fontFamily } from "@/theme";

export const styles: Record<string, SxProps> = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    zIndex: 1300,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modal: {
    backgroundColor: "#FFFFFF",
    borderRadius: "24px",
    width: "518px",
    padding: "0 0px 40px 0px",
    position: "relative",
  },
  header: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "15px 16px",
  },
  title: {
    fontFamily: fontFamily.inter,
    fontWeight: 600,
    fontSize: "28px",
    lineHeight: "36px",
    color: "#000000",
    textAlign: "center",
    marginBottom: "12px",
  },
  subtitle: {
    fontFamily: fontFamily.inter,
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "21px",
    color: "#7D8690",
    textAlign: "center",
    marginBottom: "52px",
  },
  methodBox: {
    width: "100%",
    backgroundColor: "#FAFAFB",
    borderRadius: "12px",
    padding: "16px 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    marginBottom: "16px",
  },
  methodText: {
    fontFamily: fontFamily.inter,
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#000000",
    flexGrow: 1,
  },
  amount: {
    fontFamily: fontFamily.inter,
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    color: theme.palette.custom.mainBlue,
  },
  content: {
    padding: "0px 64px",
  },
};
